<template>
  <div class="flex justify-start w-full bg-slate-100 lg:py-6 py-2 min-h-screen" style="font-family: Poppins">
    <div id="sidebarOverlay" class="w-100 h-100 flex lg:hidden p-16 fixed" @click="closeSidebar" style="
        width: 100%;
        height: 120%;
        margin-top: -4rem;
        opacity: 0.5;
        z-index: -1;
        background: rgba(100, 116, 139, 0.5) !important;
        backdrop-filter: blur(50px) !important;
      "></div>

    <div class="grid place-content-start grid-cols-12 relative w-full">
      <!-- <v-nav-menu @openBoardTip="openBoardTip" :navMenuItems="navMenuItems" :hideBoardPing="hideBoardPing"
                title="GetBoarded" parent=".layout--main" /> -->

      <sidebar id="mobileSidebar" class="flex lg:hidden" style="margin-left: -3rem; z-index: 3000" title="GetBoarded"
        parent=".layout--main" />

      <sidebar class="hidden lg:flex absolute lg:relative z-20 ml-4" title="GetBoarded" style="z-index: 3000 !important"
        parent=".layout--main" />

      <div class="col-span-12 lg:col-span-11 lg:col-start-2">
        <div id="content-overlay" />

        <!-- /Navbar -->

        <navigation style="z-index: 2000 !important" />

        <!-- /Navbar -->

        <!-- /Content -->

        <div class="content-wrapper">
          <div class="router-view user--router-view px-2 md:px-8">
            <div class="router-content org-router-content">
              <div class="content-area__content">
                <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                  v-if="!hideScrollToTop">
                  <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
                </back-to-top>

                <transition :name="routerTransition" mode="out-in">
                  <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="
                    (classesStr) => $emit('setAppClasses', classesStr)
                  " />
                </transition>
              </div>
            </div>
          </div>
        </div>

        <!-- /Content -->

        <!-- <the-footer /> -->
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/org-dashboard/horizontal-nav-menu/HorizontalNavMenu.vue";
import navMenuItems from "@/layouts/components/org-dashboard/vertical-nav-menu/navMenuItemsAdmin.js";
import TheNavbarHorizontal from "@/layouts/components/org-dashboard/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/org-dashboard/navbar/TheNavbarVertical.vue";
//   import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/org-dashboard/vertical-nav-menu/VerticalNavMenu.vue";
import NotificationDropDown from "../components/navbar/components/NotificationDropDown.vue";
import ProfileDropDown from "../components/navbar/components/ProfileDropDown.vue";
import Sidebar from "@/layouts/components/org-dashboard/vertical-nav-menu/VerticalSidebar.vue";
import Navigation from "@/layouts/components/org-dashboard/navbar/HorizontalNav.vue";

import gsap from "gsap";

export default {
  components: {
    BackToTop,
    HNavMenu,
    //   TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    NotificationDropDown,
    ProfileDropDown,
    Sidebar,
    Navigation,
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: "sticky",
      navMenuItems: navMenuItems,
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      commServerStatusCheckInProgress: false,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
    orgData(val) {
      if (val && val._id) {
        localStorage.setItem(
          `${val._id}_org_color`,
          val.primaryThemeColor ? val.primaryThemeColor : "#F2C244"
        );

        // Fetch organization config
        this.$store.dispatch("organization/fetchOrganizationConfig", {
          organizationId: this.orgData._id,
        });
      }

      if (val && val.slug) {
        localStorage.setItem(
          `${val.slug}_org_color`,
          val.primaryThemeColor ? val.primaryThemeColor : "#F2C244"
        );
      }
    },
  },
  computed: {
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },

    openSidebar() {
      const tl = gsap.timeline({
        defaults: {
          duration: 0.2,
          ease: "rough",
          repeat: 0,
        },
      });

      tl.fromTo(
        "#sidebarOverlay",
        0.2,
        { zIndex: 1000, opacity: 0 },
        { opacity: 0.5 }
      );

      tl.to("#mobileSidebar", 0.2, { marginLeft: "4rem" });
    },

    closeSidebar() {
      const tl = gsap.timeline({
        defaults: {
          duration: 0.3,
          ease: "rough",
          repeat: 0,
        },
      });

      tl.to("#mobileSidebar", 0.2, { marginLeft: "-3rem" });

      tl.fromTo("#sidebarOverlay", 0.2, { opacity: 0.5 }, { opacity: 0 });

      tl.fromTo("#sidebarOverlay", 0.2, { zIndex: 3000 }, { zIndex: -10 });
    },
  },
  created() {
    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);

    if (this.$store.state.auth.isUserLoggedIn) {
      this.$vs.loading();

      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          // // console.log(res.data);
          this.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          this.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          this.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          this.$store.commit("editor/SET_PROJECTS", res.data.projects);
          this.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
          this.$vs.loading.close();
        })
        .catch((err) => {
          throw err;
        });

      //fetch current organization
      const organizationIdORSlug = this.$route.params.organizationId;
      if (organizationIdORSlug) {
        try {
          this.$store
            .dispatch(
              "organization/fetchOrganizationBySlug",
              organizationIdORSlug
            )
            .then((res) => {
              if (res.data.total === 0) {
                this.$store.dispatch(
                  "organization/fetchOrganizationById",
                  organizationIdORSlug
                );
              } else {
                this.$store.dispatch(
                  "organization/fetchOrganizationById",
                  res.data.data[0]._id
                );
              }
            });
        } catch (error) {
          throw error;
        }
      }

      if (this.orgData && this.orgData._id) {
        // Fetch organization config
        this.$store.dispatch("organization/fetchOrganizationConfig", {
          organizationId: this.orgData._id,
        });
      }
    }
  },

  beforeCreate() {
    this.$store.commit(
      "UPDATE_PRIMARY_COLOR",
      localStorage.getItem(`${this.$route.params.organizationId}_org_color`)
    );
  },
  beforeDestroy() {
    this.$store.commit("UPDATE_PRIMARY_COLOR", "#F2C244");
  },
};
</script>

<style>
.router-view {
  padding: 1.5rem 2.2rem 0px 0px !important;
}

/*.router-content {
  margin-top: 0 !important;
}*/

.org-card.vx-card {
  background: #ffffff;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  height: 100%;
  min-height: -webkit-fit-content;
}

/*h1, h2, h3, h4, h5, h6 {
    color: #30384B !important;
  }*/

.org--main h1,
.org--main h2,
.org--main h3,
.org--main h4,
.org--main h5,
.org--main h6 {
  color: #30384b !important;
}

.org--main p {
  color: #798ba0 !important;
}

.org--main .text-white {
  color: white !important;
}

label {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
  color: #000000;
}

.required-field {
  color: red;
}

.vs-con-input .vs-input--input {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 6px;

  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;
}
</style>
